
import { mapState } from "vuex";

import { toBlob } from "html-to-image";
import printTemplateKot from "../print-template/print-template-kot.vue";
import printTemplateBillPrint from "../print-template/print-template-bill-print.vue";
import printTemplateItemWiseReport from "../print-template/print-template-item-wise-report.vue";
import { DEFAULT_PRINT_DPI } from "../../constants/Others";
const PRINT_TYPE_KOT = "kot";
const PRINT_TYPE_BILL = "bill";
const PRINT_TYPE_REPORT_KOT = "report-kot";

const PRINT_VIA_QZ = "print-via-qz";
const PRINT_VIA_BLUETOOTH = "print-via-bluetooth";
export default {
  mounted() {
    this.$nuxt.$on("initiate-print", this.initiatePrint);
  },
  data() {
    return {
      printQueue: [],
      isPrintingInProgress: false
    };
  },
  computed: {
    ...mapState("restaurant", ["printers"]),
    getPrintVia() {
      return this.isAndroid() ? PRINT_VIA_BLUETOOTH : PRINT_VIA_QZ;
    },
    isQzPrint() {
      return this.getPrintVia === PRINT_VIA_QZ;
    },
    getPrinterWidth() {
      return this.$ls.get("printer-type", "md") == "sm" ? 2 : 3;
    },
    getPrinterDpi() {
      return Number(this.$ls.get("printer-dpi", DEFAULT_PRINT_DPI));
    }
  },
  methods: {
    async selectDefaultPrinter(defaultPrinter = null) {
      return (defaultPrinter = await qz.printers
        .getDefault()
        .then(function (defaultPrinter) {
          console.log("defaultprinter:: ", defaultPrinter, new Date());
          return defaultPrinter;
        }));
    },

    //Maintain fn initiatePrint with legecy param structure
    async initiatePrint(
      order,
      type,
      fetchData,
      part,
      dispatch,
      copy,
      isOnlineOrder,
      selectedPrinters,
      source
    ) {
      if (!this.isHtmlPrintingEnabled()) return;
      if (type === "kot") {
        if (this.isQzPrint) {
          selectedPrinters.forEach((printer) => {
            const items = order.items.filter(
              (item) =>
                !item.kot_disabled &&
                item.printer_id &&
                item.printer_id == printer.id
            );
            if (items && items.length) {
              this.addKotPrintToQueue({
                items,
                order,
                source,
                printer,
                isConsolidatedPrint: false
              });
            }
          });
        } else {
          this.addKotPrintToQueue({
            items: order.items,
            order,
            source,
            isConsolidatedPrint: false
          });
        }
      } else if (type === "master-kot") {
        if (this.isQzPrint) {
          const masterPrinters = this.printers.filter(
            (printer) => printer.is_master_printer
          );
          masterPrinters.forEach((printer) => {
            this.addKotPrintToQueue({
              items: order.items,
              order,
              source,
              printer,
              isConsolidatedPrint: true
            });
          });
        } else {
          this.addKotPrintToQueue({
            items: order.items,
            order,
            source,
            isConsolidatedPrint: true
          });
        }
      } else if (type === "bill") {
        this.addBillPrintToQueue({
          items: order.items,
          order
        });
      } else if (type === "report-kot") {
        this.addReportPrintToQueue({
          items: order
        });
      } else {
        console.log("what???", new Date());
      }
    },

    addKotPrintToQueue({
      items = [],
      order = {},
      source,
      printer,
      isConsolidatedPrint = false
    }) {
      this.addToPrintQueue(
        {
          type: PRINT_TYPE_KOT,
          props: {
            order,
            items,
            source,
            isConsolidatedPrint
          }
        },
        printer
      );
    },
    async addBillPrintToQueue({ items = [], order = {} }) {
      const printer = this.isQzPrint
        ? await this.selectDefaultPrinter()
        : undefined;
      this.addToPrintQueue(
        {
          type: PRINT_TYPE_BILL,
          props: {
            order,
            items
          }
        },
        printer
      );
    },
    async addReportPrintToQueue({ items = [] }) {
      const printer = this.isQzPrint
        ? await this.selectDefaultPrinter()
        : undefined;
      this.addToPrintQueue(
        {
          type: PRINT_TYPE_REPORT_KOT,
          props: {
            items
          }
        },
        printer
      );
    },
    async printTemplateReady() {
      const element = document.getElementById("print-preview");
      const printQuality = this.$ls.get("print-quality", 3);
      try {
        const blob = await toBlob(element, {
          pixelRatio: printQuality
        });
        // if (window.saveAs) {
        //   window.saveAs(blob, "my-node.png");
        // } else {
        //   FileSaver.saveAs(blob, "my-node.png");
        // }
        const content = await this.blobToBase64(blob);
        this.printQueue[0].printData = content;
        this.executePrintFromQueue();
      } catch (error) {
        console.log(error, new Date());
      }
    },
    addToPrintQueue({ type, props }, printer) {
      let componentName = null;
      if (type === PRINT_TYPE_KOT) {
        componentName = "print-template-kot";
      } else if (type === PRINT_TYPE_BILL) {
        componentName = "print-template-bill-print";
      } else if (type === PRINT_TYPE_REPORT_KOT) {
        componentName = "print-template-item-wise-report";
      }
      this.printQueue.push({ componentName, props, printer, printData: null });
    },
    executePrintFromQueue() {
      if (
        !this.printQueue.length ||
        !this.printQueue[0]?.printData ||
        this.isPrintingInProgress
      )
        return;
      this.isPrintingInProgress = true;
      const item = this.printQueue[0];
      if (this.isQzPrint) {
        const data = [
          {
            type: "pixel",
            format: "image",
            flavor: "base64", // file
            data: item.printData
          }
        ];
        const itemPrinter = item.printer?.name || item.printer;
        qz.printers
          .find(itemPrinter)
          .then((printer) => {
            let config = qz.configs.create(printer);
            // this.printQueue.push({ config, data });

            qz.print(config, data)
              .then(() => {
                console.log("Qz print success", new Date());
              })
              .catch((error) => {
                this.$nuxt.$emit(
                  "show-error-toast",
                  "QZ Printer is not responding. Please open the QZ Tray app to connect the KOT printer"
                );
                console.error(error, new Date());
              })
              .finally(() => {});
          })
          .catch((error) => {
            this.$nuxt.$emit(
              "show-error-toast",
              "QZ Printer is not responding. Please open the QZ Tray app to connect the KOT printer"
            );
            console.error(error, new Date());
          });
        this.executePrintPostAction();
      } else {
        try {
          Android.initBluetoothHtmlPrint(
            JSON.stringify({
              content: item.printData,
              config: {
                width: this.getPrinterWidth,
                dpi: this.getPrinterDpi
              }
            })
          );
        } catch (error) {
          this.$nuxt.$emit("show-error-toast", error);
        }
        this.executePrintPostAction();
      }
    },
    executePrintPostAction() {
      setTimeout(() => {
        this.isPrintingInProgress = false;
        this.printQueue.shift();
        this.executePrintFromQueue();
      }, 500);
    }
  }
};
